<aslib-title Text="Parâmetros serviço notificação por e-mail" SubText=" " Icon="fa fas fa-cog"></aslib-title>
<router-outlet></router-outlet>
<br>
<div class="col-md-8">
    <gpa-param-notificacao></gpa-param-notificacao>
</div>
<br>


// WEBPACK FOOTER //
// ./src/app/pagamento/adm-pagamento/adm-parametro.component.html